<template>
    <div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="firstname">Vārds</label>
                    <input type="text" class="form-control" name="firstname" id="firstname" v-model="firstname" :class="{'is-invalid':errors && ( 'firstname' in errors)}">
                    <small class="text-danger" v-if="errors && errors.firstname">{{errors.firstname[0]}}</small>
                </div>
                <div class="form-group">
                    <label for="lastname">Uzvārds</label>
                    <input type="text" class="form-control" name="lastname" id="lastname" v-model="lastname" :class="{'is-invalid':errors && ( 'lastname' in errors)}">
                    <small class="text-danger" v-if="errors && errors.lastname">{{errors.lastname[0]}}</small>
                </div>
                <div class="form-group">
                    <label for="email">E-pasts</label>
                    <input type="text" class="form-control" name="email" id="email" v-model="email" :class="{'is-invalid':errors && ( 'email' in errors)}" disabled>
                    <small class="text-muted">E-pasta adresi var mainīt tikai sistēmas administrators.</small>
                </div>
                <div class="form-group">
                    <label for="phone">Tālrunis</label>
                    <input type="text" class="form-control" name="phone" id="phone" v-model="phone" :class="{'is-invalid':errors && ( 'phone' in errors)}">
                    <small class="text-danger" v-if="errors && errors.phone">{{errors.phone[0]}}</small>
                </div>
                <div class="form-group">
                    <label for="position">Amats</label>
                    <input type="text" class="form-control" name="position" id="position" v-model="position" :class="{'is-invalid':errors && ( 'position' in errors)}">
                    <small class="text-danger" v-if="errors && errors.position">{{errors.position[0]}}</small>
                </div>
                <div class="form-group text-right">
                    <button class="btn btn-primary" v-if="loading == false" @click="saveProfile()">Saglabāt</button>
                    <button type="button" class="btn btn-primary"  v-if="loading == true" disabled>Saglabāt</button>
                </div>
            </div>
            <div class="col-md-6">
                <button class="btn btn-primary" data-toggle="modal" data-target="#pincodemodal">PIN koda maiņa</button>
                <div class="modal fade" tabindex="-1"  id="pincodemodal" ref="vuemodal">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header bg-primary text-white">
                                <h5 class="modal-title">PIN koda maiņa</h5>
                                <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="pincode1">Jaunais PIN kods</label>
                                            <input id="pincode1" type="password" v-model="pincode1" class="form-control" :class="{'is-invalid':errors && ( 'pincode1' in errors)}">
                                            <small class="text-danger" v-if="errors && errors.pincode1">{{errors.pincode1[0]}}</small>
                                        </div>
                                        <div class="form-group">
                                            <label for="pincode2">Jaunais PIN kods (atkārtoti)</label>
                                            <input id="pincode2" type="password" v-model="pincode2" class="form-control" :class="{'is-invalid':errors && ( 'pincode2' in errors)}">
                                            <small class="text-danger" v-if="errors && errors.pincode2">{{errors.pincode2[0]}}</small>
                                        </div>
                                        <hr>
                                        <div class="form-group">
                                            <label for="password">Parole</label>
                                            <input id="password" type="password" v-model="password" class="form-control" :class="{'is-invalid':errors && ( 'password' in errors)}">
                                            <small class="text-danger" v-if="errors && errors.password">{{errors.password[0]}}</small>
                                            <small class="text-muted" v-else>Ievadiet paroli, lai apstiprinātu PIN maiņu.</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-primary" v-if="loading == false" @click="savePin()">Saglabāt</button>
                                <button type="button" class="btn btn-primary"  v-if="loading == true" disabled>Saglabāt</button>
                            </div>
                        </div>
                    </div>
                </div>
                <button class="btn btn-primary" data-toggle="modal" data-target="#passwordmodal">Paroles maiņa</button>
                <div class="modal fade" tabindex="-1"  id="passwordmodal" ref="vuemodal">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header bg-primary text-white">
                                <h5 class="modal-title">Paroles maiņa</h5>
                                <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="newpass1">Jaunā parole</label>
                                            <input id="newpass1" type="password" v-model="newpass1" class="form-control" :class="{'is-invalid':errors && ( 'newpass1' in errors)}">
                                            <small class="text-danger" v-if="errors && errors.newpass1">{{errors.newpass1[0]}}</small>
                                        </div>
                                        <div class="form-group">
                                            <label for="newpass2">Jaunā parole (atkārtoti)</label>
                                            <input id="newpass2" type="password" v-model="newpass2" class="form-control" :class="{'is-invalid':errors && ( 'newpass2' in errors)}">
                                            <small class="text-danger" v-if="errors && errors.newpass2">{{errors.newpass2[0]}}</small>
                                        </div>
                                        <hr>
                                        <div class="form-group">
                                            <label for="password">Esošā parole</label>
                                            <input id="password" type="password" v-model="password" class="form-control" :class="{'is-invalid':errors && ( 'password' in errors)}">
                                            <small class="text-danger" v-if="errors && errors.password">{{errors.password[0]}}</small>
                                            <small class="text-muted" v-else>Ievadiet pašreizējo paroli, lai apstiprinātu paroles maiņu.</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-primary" v-if="loading == false" @click="savePassword()">Saglabāt</button>
                                <button type="button" class="btn btn-primary"  v-if="loading == true" disabled>Saglabāt</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>


</template>
<script>
export default  {
    props:['user'],
    mounted()
    {
        this.firstname = this.$props.user.firstname;
        this.lastname = this.$props.user.lastname;
        this.position = this.$props.user.position;
        this.email = this.$props.user.email;
        this.phone = this.$props.user.phone;
    },
    data()
    {
        return {
            loading:false,
            errors:false,

            firstname:"",
            lastname:"",
            position:"",
            phone:"",
            email:"",
            newpass1:"",
            newpass2:"",
            password:"",
            pincode1:"",
            pincode2:""
        }
    },
    methods:{
        saveProfile()
        {
            var that = this;
            that.errors = [];
            that.loading = true;
            axios.post('/dashboard/api/profile',{
                firstname: this.firstname,
                lastname: this.lastname,
                position: this.position,
                phone: this.phone
            }).then(response => {
                if(response.data.status == "success")
                {
                    that.user = response.data.user;
                    that.$toast.open({
                        message:response.data.message,
                        type: 'success',
                    });
                    that.loading = false;
                }
                if(response.data.status == "error")
                {
                    that.user = response.data.user;
                    that.errors = response.data.errors;
                    that.$toast.open({
                        message:response.data.message,
                        type: 'error',
                    });
                    that.loading = false;
                }
            })
        },
        savePin()
        {
            var that = this;
            that.errors = [];
            that.loading = true;
            axios.post('/dashboard/api/profile/pin',{
                pincode1:this.pincode1,
                pincode2: this.pincode2,
                password: this.password
            }).then(response => {
                if(response.data.status == "success")
                {
                    that.user = response.data.user;
                    that.$toast.open({
                        message:response.data.message,
                        type: 'success',
                    });
                    $(that.$refs.vuemodal).modal('hide');
                    that.loading = false;
                    that.pincode1 = "";
                    that.pincode2 = "";
                    that.password = "";
                }
                if(response.data.status == "error")
                {
                    that.user = response.data.user;
                    that.errors = response.data.errors;
                    that.password = "";
                    that.$toast.open({
                        message:response.data.message,
                        type: 'error',
                    });
                    that.loading = false;
                }
            })
        },
        savePassword()
        {
            var that = this;
            that.errors = [];
            that.loading = true;
            axios.post('/dashboard/api/profile/password',{
                newpass1:this.newpass1,
                newpass2:this.newpass2,
                password: this.password
            }).then(response => {
                if(response.data.status == "success")
                {
                    that.user = response.data.user;
                    that.$toast.open({
                        message:response.data.message,
                        type: 'success',
                    });
                    $(that.$refs.vuemodal).modal('hide');
                    that.loading = false;
                    that.newpass1 = "";
                    that.newpass2 = "";
                    that.password = "";
                }
                if(response.data.status == "error")
                {
                    that.user = response.data.user;
                    that.errors = response.data.errors;
                    that.password = "";
                    that.$toast.open({
                        message:response.data.message,
                        type: 'error',
                    });
                    that.loading = false;
                }
            })
        }
    }
}
</script>
<style lang="scss">

</style>
